function cov_24v8l3utoh() {
  var path = "/app/src/constants/dictionary-map-language.ts";
  var hash = "606c70dccd3f524298685b70c6812f9b7b06fdb2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/dictionary-map-language.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 17,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "606c70dccd3f524298685b70c6812f9b7b06fdb2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24v8l3utoh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24v8l3utoh();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Lang, LangDictionary, Locale } from 'src/types/lang-locale-type';
export var dictionaryMapLanguage = (cov_24v8l3utoh().s[0]++, _defineProperty(_defineProperty({}, LangDictionary.en, {
  lang: Lang.en,
  locale: Locale['en-US']
}), LangDictionary.ar, {
  lang: Lang.ar,
  locale: Locale['ar-AE']
}));